import { render, staticRenderFns } from "./ComparedProductListItemBar.vue?vue&type=template&id=23b7d739"
import script from "./ComparedProductListItemBar.vue?vue&type=script&lang=js"
export * from "./ComparedProductListItemBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports